<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="keyword" label="关键词">
        <el-input
          v-model.trim="searchModel.keyword"
          placeholder="输入委托单位或项目名称"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="dateRange" label="创建时间">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" storageKey="hiddenColumns_experimentReport" @onRefresh="getTableData()"></TableHeader>

      <el-table
        ref="table"
        :data="tableData"
        border
        stripe
        height="100%"
        style="width: 100%"
        v-loading="tableLoading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="序号" align="center" width="50">
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="委托编号" width="160" align="center">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleProcess(row)">{{ row.reportCodeStart }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="client" label="委托单位" align="center"></el-table-column>
        <el-table-column prop="projectName" label="项目名称" align="center" min-width="220"></el-table-column>
        <el-table-column prop="sfcn" label="委托单位联系人" align="center"></el-table-column>
        <el-table-column prop="sampleName" label="报告数量" align="center" width="150">
          <template v-slot="{ row }">
            <el-progress
              :stroke-width="8"
              :percentage="Math.round((row.pzNum / row.totalNum) * 100)"
              :format="() => `${row.pzNum}/${row.totalNum}`"
            ></el-progress>
          </template>
        </el-table-column>
        <el-table-column prop="sendDate" label="商定检测日期" align="center" width="120"></el-table-column>

        <el-table-column label="操作" width="240" header-align="center" fixed="right">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleDetail(row)">详情</el-link>
            <el-link type="primary" @click="handleUpload(row)">上传总报告</el-link>
            <el-link v-if="row.docPath" type="danger" @click="handleDownload(row)">下载总报告</el-link>
            <br />
            <el-link v-if="row.docPath" type="primary" @click="handleQrCode(row)">添加二维码</el-link>
            <el-link v-if="row.docPathQrc" type="danger" @click="handleDownloadFinal(row)">下载总报告（带二维码）</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 流程信息 -->
    <ProcessDialog :visible.sync="processVisible" :activeId="activeRowId" />
    <!-- 上传总报告 -->
    <UploadReport :visible.sync="uploadVisible" :activeInfo="activeRowInfo" @refresh="getTableData()" />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import ProcessDialog from '@/components/BusinessComponents/ProcessDialog';
import UploadReport from './components/UploadReport';
import modal from '@/utils/modal';

import { getEntrustmentSetList, generateSetDocQRCode } from '@/api/entrust';

export default {
  components: { TableHeader, ProcessDialog, UploadReport },
  data() {
    return {
      collapsed: true,
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        state: 2,
        keyword: '',
        flowState: 2,
        dateRange: []
      },
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      tableSelection: [],
      // 弹窗
      activeRowId: null,
      activeRowInfo: {},
      transferVisible: false,
      processVisible: false,
      uploadVisible: false
    };
  },
  computed: {},
  watch: {},
  filters: {},
  methods: {
    handleSelectionChange(val) {
      this.tableSelection = val;
    },
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getEntrustmentSetList({ ...this.searchModel, startTime, endTime });

      this.dataTotal = data.count;
      this.tableData = data.list || [];

      this.tableLoading = false;
    },
    formatReportProgress(row) {
      return `${row.reportFinished}/${row.reportTotal}`;
    },
    handleFlowState() {
      this.getTableData(true);
      this.$nextTick(() => {
        this.$refs.table.doLayout(); // 重置表格布局
      });
    },
    handleDetail(row) {
      this.$router.push(`/reportManagement/${row.id}`);
    },
    handleProcess(row) {
      this.activeRowId = row.id;
      this.processVisible = true;
    },
    handleUpload(row) {
      this.activeRowInfo = row;
      this.uploadVisible = true;
    },
    async handleQrCode(row) {
      try {
        modal.loading('文件生成中...');
        await generateSetDocQRCode({ id: row.id });
        this.getTableData();
        this.$message.success('二维码添加成功！');
      } finally {
        modal.closeLoading();
      }
    },
    handleDownload(row) {
      this.downloadFileUpdateName(row.docPath, `${row.reportCodeStart} ${row.projectName}总报告`);
    },
    handleDownloadFinal(row) {
      this.downloadFileUpdateName(row.docPathQrc, `${row.reportCodeStart} ${row.projectName}总报告`);
    },
    downloadFileUpdateName(fileUrl, fileName) {
      if (!fileUrl) return this.$message.warning('暂无对应文件!');
      const timestamp = new Date().getTime();
      const encodedFileUrl = encodeURIComponent(fileUrl);
      const fullUrl = `${process.env.VUE_APP_BASE_API}/${encodedFileUrl}?t=${timestamp}`;

      // 创建一个隐藏的<a>标签
      const link = document.createElement('a');
      link.href = fullUrl;
      link.download = fileName; // 设置下载的文件名
      document.body.appendChild(link);
      link.click(); // 触发点击事件开始下载
      document.body.removeChild(link); // 下载完成后移除<a>标签
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped></style>
